module.exports = __webpack_public_path__ + "static/media/OkkjifastBackground.03bca7f1.png";